module.exports = {"installText":"Como instalar?","infoText":"Você pode sempre consultar esses passo-a-passo em caso de dúvida","carType":{"car":"Carro de passeio e utilitário","truck":"Caminhão","bus":"Ônibus"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/HowToInstall/data.json
// module id = 2045
// module chunks = 0